import Modal from './styled';

export default Modal;
